module.exports = __webpack_public_path__ + "img/02fe4e2.jpg";